import {Alert, Tab, Tabs} from '@mui/material';
import React, {useEffect, useState} from 'react';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography';
import {DataPageDetailDto} from '../../../../Component/Model/Dto/VerificationWorkflow';
import { StepTable } from './StepTable';

interface IProps {
    scorecardId: string;
    dataPages: DataPageDetailDto[];
    refresh: () => void;
}

export const TabSection = (props: IProps) => {

    const [selectedTab, setSelectedTab] = useState<number>(0);

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
    };

    useEffect(() => {
        if (selectedTab >= props.dataPages.length) {
            setSelectedTab(0);
        }
    }, [props.dataPages]);

    const renderTabs = props.dataPages.length > 1 ? (
        <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="secondary"
            textColor="primary"
            variant="fullWidth"
            sx={{ backgroundColor: "#BBE3EE", mb:1 }}
        >
            {props.dataPages.map((dataPage, index) => (
                <Tab key={index} label={dataPage?.name} />
            ))}
        </Tabs>
    ) : null;

    return (
        <div>
            {renderTabs}
            {!props.dataPages[selectedTab]?.hasAccess &&
                <Alert severity="warning" sx={{mb:1}}>You do not have access to this page. Please contact your Verification Agency to find out more.</Alert>
            }
            <MDTypography variant="body2" paragraph>
                {props.dataPages[selectedTab]?.description }
            </MDTypography>
            <StepTable key={selectedTab} scorecardId={props.scorecardId} dataPage={props.dataPages[selectedTab]} refresh={props.refresh} hasAccess={props.dataPages[selectedTab]?.hasAccess}/>
        </div>
    );
};
